import { H1, StatusInfoModal, StatusInfoTypes } from '@catalyze/ui';

import { StyledText } from './styled';

export const SuccessfullMessage = () => (
    <StatusInfoModal type={StatusInfoTypes.SUCCESS}>
        <H1>Reset Request Submitted</H1>
        <StyledText>
            You’ll receive an email from us with the account activation link
        </StyledText>
        <StyledText>You can close this browser tab.</StyledText>
    </StatusInfoModal>
);

export const ErrorMessage = () => (
    <StatusInfoModal type={StatusInfoTypes.ERROR}>
        <H1>Error occured</H1>
        <StyledText>Try again later</StyledText>
    </StatusInfoModal>
);
